// tslint:disable: trailing-comma
export interface IPrice {
  gross: number;
  tax: number;
  net: number;
  currency: {
    // tslint:disable-next-line:no-any
    links: any
    currencyId: number
  };
}
